import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CLFontIcon from '../../components/CLFontIcon';

import { Container, UnitsCount, Row } from './styled';

const ListingParams = ({ listing }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        {listing.bedroom_display && (
          <div>
            <CLFontIcon icon="bed" />
            <strong>{listing.bedroom_display}</strong>
            {' '}
            {t('bed', 'Bed')}
          </div>
        )}

        {listing.bath_display && (
          <div>
            <CLFontIcon icon="bathroom" />
            <strong>{listing.bath_display}</strong>
            {' '}
            {t('bath', 'Bath')}
          </div>
        )}

        {listing.size_display && (
          <div>
            <CLFontIcon icon="size" />
            <strong>{listing.size_display}</strong>
            {' '}
            {t('sqft', 'SQFT')}
          </div>
        )}
      </Row>

      {!!listing.unit_count && (
        <UnitsCount>
          {t('units', 'Units')}
          {': '}
          <strong>{listing.unit_count}</strong>
        </UnitsCount>
      )}
    </Container>
  );
};

ListingParams.propTypes = {
  listing: PropTypes.object.isRequired,
};

export default ListingParams;
